import React, { useEffect, useState } from "react";
import "../../styles/VenuePage.scss";

interface VenueDetail {
  id: number;
  title: string;
  description: string;
  image?: string;
}

interface VenueData {
  venue: {
    name: string;
    address: string;
    details: VenueDetail[];
  };
}

export default function VenuePage() {
  const [venueData, setVenueData] = useState<VenueData | null>(null);

  useEffect(() => {
    fetch("/resources/venue.json")
      .then((res) => res.json())
      .then(setVenueData)
      .catch(console.error);
  }, []);

  if (!venueData) return null;

  const venue = venueData.venue;

  return (
    <div className="venue-wrapper">
      <header className="venue-header">
        <div className="v-header-bg" />
        <div className="v-header-content">
          <h1 className="venue-page-title v-cutout-text" data-text="Venue">
            Venue
          </h1>
          <h2
            className="venue-page-title v-cutout-text sub"
            data-text="APLIC 2027"
          >
            APLIC 2027
          </h2>
        </div>
      </header>

      <section className="venue-page-section">
        <div className="venue-page-container">
          <h2 className="venue-title">{venue.name}</h2>
          <p className="venue-address">{venue.address}</p>

          {venue.details.map((detail, index) => (
            <div
              key={detail.id}
              className={`venue-detail ${
                index % 2 === 0 ? "image-left" : "image-right"
              }`}
            >
              <div className="venue-detail-image">
                {detail.image ? (
                  <img src={detail.image} alt={detail.title} />
                ) : (
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18..."
                    width="100%"
                    height="450"
                    style={{ border: 0 }}
                    loading="lazy"
                  />
                )}
              </div>

              <div className="venue-detail-text">
                <h3>{detail.title}</h3>
                <p
                  dangerouslySetInnerHTML={{
                    __html: detail.description,
                  }}
                />
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
